import NProgress from "nprogress";
import "../../node_modules/nprogress/nprogress.css";

import router from "./routes";

router.beforeResolve((to, from, next) => {
  if (to.name) {
    NProgress.start();
  }
  next();
});

router.afterEach((to, from) => {
  NProgress.done();
});

export default router;
